import { types } from "util";

export const locale = {
  lang: "en",
  data: {
    MENU: {
      DASHBOARD: {
        chatView: "Chat View",
        supportChat: "Support Chat",
        COLLAPSIBLE: "Dashboard",
        BADGE: "2",
        ANALYTICS: "Analytics",
        SUBCATEGORY: "Subcategory",
        SELECT_SUBCATEGORY: "Select Subcategory",
        CATEGORYy: " Category",
        SELECT_CATEGORY: "Select a category",
        ECOMMERCE: "E-Commerce",
        id: "ID",
        REAL: "Real User",
        FAKE: "Fake User",
        NO_FILE_SELECTED: "No file selected",
        BOOK_TYPE: "Book Type",
        SELECT_BOOK_TYPE: "Select book type",
        PRINTED_BOOK: "Printed Book",
        AUDIO_BOOK: "Audio Book",
        sendNotification: "Send Notification",
        openscreenlist: "Open Screen List",
        incorrectInfo: "incorrect Email or Password",
        rememberMe: "Remember Me",
        LOGOUT: "Logout",
        acceptanceMsg: "are you sure to delete this book ?",
        signInMessage: "Please sign-in to your account and start the adventure",
        image: "Image",
        email: "Email",
        password: "Password",
        forgetPassword: "Forget Password ?",
        signIn: "Sign In",
        maktabity: "MAKTABITY",
        Main_Category: " Main Category ",
        Subcategory_Name: " Subcategory Name  ",
        loading: "Loading...",
        FIELD_REQUIRED: "This field is required",
        POSITIVE_NUMBER: "Must be a positive number",
        welcomeMsg: "Welcome To",
        profile: "Profile",
        closeAcc: "Account Suspenition",
        followers: "Followers",
        following: "Following",
        HOME: "Home",
        WELCOME_MESSAGE:
          "   Maktbity | Your Platform for Reading, Writing & Creativity",
        WELCOME_MESSAGEE:
          "              Maktbity is a digital platform that lets you read novels and stories, or publish your own writings easily. Join thousands of writers and readers in a world full of creativity and interaction.",
        WELCOME_MESSAGEEE:
          "             Keywords: Maktbity, books, novels, stories, writing, reading, literary platform, writers, readers",
        next: "Next",
        prev: "Prev",
        addSubCategory: "Add SubCategory",
        subCategoryName: "SubCategory Name",
        subCategoryId: "SubCategory Id",
        editSubCategory: "Edit SubCategory",

        TOTAL_USERS: "Total Users",
        BOOKS_COUNT: "Number of Books",
        BOOKS: "Books",
        BOOKS_LIST: "Books List",
        BOOK_DESCRIPTION: "Book Description",
        BOOK_NAME: "Book Name",
        CATEGORY: "Category",
        SUB_CATEGORY: "Sub Category",
        EXP: "Exp",
        EDIT: "Edit",
        EDITS: "Edit Links",
        DATE: "Date",
        CLICK: "Email Click",
        CLICK_LIST: "Email Click List",
        CAMPAIGN: "Campaign",
        CLICKED_AT: "Clicked At",
        USER_AGENT: "User Agent",
        ADD_SUBCATEGORY: "Add SubCategory",
        FAKE_USERS: "Fake Users",
        FAKE_USERS_LIST: "Fake Users List",
        NAME: "Name",
        DATE_OF_BIRTH: "Date Of Birth",
        EMAIL: "Email",
        MOBILE: "Mobile",
        GENDER: "Gender",
        FOLLOWERS: "Followers",
        FOLLOWING: "Following",
        INFO: "Info",
        SUB_CATEGORIES: "Sub Categories",
        SUB_CATEGORIES_LIST: "Sub Categories List",
        LOGO: "Logo",
        MAIN_CATEGORIES: "Main Categories",
        MAIN_CATEGORIES_LIST: "Main Categories List",
        ADD_CATEGORY: "Add Category",
        CATEGORY_NAME: "Category Name",
        MOST_VIEW_BOOKS: "Most View Books",
        MOST_VIEW_BOOKS_LIST: "Most View Books List",
        changeLanguage: "Change Language",
        FAKE_USER: {
          NAME: "Name",
          EMAIL: "Email",
          MOBILE: "Mobile",
          COUNTRY_ID: "Country",
          CITY_ID: "City",
          PASSWORD: "Password",
          PASSWORD_CONFIRMATION: "Confirm Password",
          IMAGE: "Image",
          SUBMIT: "Submit",
        },

        ARTICLES: "Articles",
        ARTICLES_LIST: "Articles List",
        BODY: "Body",
        TITLE: "Title",
        AUTHOR_NAME: "Author Name",
        FILE_TYPE_ID: "File Type ID",
        IMAGE: "Image",
        SELECTED_IMAGE_EDIT: "Selected Image (Edit Condition)",
        BOOK_FILE: "Book File",
        SUBMIT: "Submit",
        USERS: "Users",
        USERS_LIST: "Users List",
        SHOW: "Show",
        ENTRIES: "Entries",
        SEARCH: "Search",
        DAILY_USERS: "Daily Users",
        DAILY_USERS_LIST: "Daily Users List",
        TODAY_REGISTERED_USERS: "New registrations today",
        WEEK_REGISTERED_USERS: "New registrations this week",
        MONTH_REGISTERED_USERS: "New registrations this month",
        ACTIONS: "Actions",
        DELETE: "Delete",
        MALE: "Male",
        CONFIRM_DELETE_TITLE: "Are you sure?",
        CONFIRM_DELETE_TEXT: "This will delete the book permanently.",
        YES_DELETE: "Yes, delete it!",
        TEXT: "This will delete the book permanently.",
        CONFIRM: "Yes, delete it!",
        DELETED_TITLE: "Deleted!",
        UPLOAD_IMAGE: "Upload Image",
        NAME_AR: "Name (Arabic)",
        ADD_BOOK: "Add Book",
        FILL_BOOK_DETAILS: "Fill in the book details",
        ERROR: "Error",
        ASK_BOOKS_LIST: "Ask Books List",
        ASK_BOOKS: "Ask Books",
        SEND_NOTIFICATION: "Send Notification",
        LAST_LOGIN: "Last login",
        SELECTED_IMAGE: "Selected Image",
        MAKTABTI: "Maktbity",
        NOTIFICATION_SENT_SUCCESS: "Notification sent successfully",
        NOTIFICATION_SENT_ERROR: "Failed to send notification",
        INVALID_USER_ID: "Invalid user ID",
        SELECT_IMAGE: "Please select an image.",
        USER_SAVED: "User saved successfully",
        FIX_ERRORS: "Please fix the errors and try again.",
        NAME_EN: "Name (English)",
        USER_NAME: "User Name",
        AUTHOR: "Author",

        STATUS: "Status",
        BODY_AR: "Body (Arabic)",
        DAILY_ARTICLES: "Daily Articles",
        BODY_EN: "Body (English)",
        ADD_OPEN_SCREEN: "Add Open Screen",
        DELETED_TEXT: "The book has been deleted.",
        ERROR_TITLE: "Error!",
        SOCIAL_LINKS_LIST: "SOCIAL LINKS List",
        URL: "URL",
        OPEN_LINK: "Open Link",
        CLICKS: "CLICKS",
        SOCIAL_LINKS: "Social Links",
        ERROR_TEXT: "Something went wrong.",
        FEMALE: "Female",
        SOCIAL_LINKS_URL: "Social Links URL",
        PREVIEW: "Preview",
        TITLEe: "Installment Manager",
        LIST: "Installment Manager List",
        DEVICE_TYPE: "Device Type",
        TOTAL_AMOUNT: "Total Amount",
        DOWN_PAYMENT: "Down Payment",
        MOBILE_NUMBER: "Mobile Number",
        NOT_SPECIFIED: "Not Specified",
        SAVE: "Save",
        SUCCESS: "Success",
        OK: "OK",
        CANCEL: "Cancel",
        BOOK_ADDED: "Book added successfully",
        books: "Books",
        mostViewBook: "Most View Books",
        mainCategory: "Main Categories",
        subCategory: "Sub categories",
        reports: "Reports",
        contests: "Contests",
        stories: "Stories",
        CONTENT: "Content", 
        writers: "Writers",
        REPORTS: "Reports",
        ENTER_TITLE: "Enter notification title",
        ENTER_BODY: "Enter notification body",
        SEND: "Send Notification",
        REPORTS_LIST: "Reports List",
        openScreens: "Open Screens",
        BOOK_ID: "Book ID",
        REPORTS_COUNT: "Reports Count",
        ENTER_IMAGE_URL: "Enter image URL",
        ENTER_FILE_URL: "Enter book file URL",
        fakeUsers: "Fake Users",
        fakeUserss: "Fake Users",
        LAST_LOGGED_TIME: "Last Logged Time",
        dailyUser: "Daily Users",
        users: "Users",
        usersM: " Most View Users   ",
        list: "List",
        add: "Add",
        addS: "Add Store Book",
        ads: "Ads",
        counselors: "Counselors",
        stores_offers: "Stores Offers",
        cancelation_reason: "Cancelation Reason",
        companies: "Companies",
        consulting: "Consulting",
        categories: "Categories",
        services: "Services",
        tags: "Tags",
        articles: "Articles",
        offers: "Offers",
        plantcards: "Plant Cards",
        UNEXPECTED_ERROR: "Something went wrong. Please try again.",
        Settings: "Settings",
        ShowDetails: "Show Details",
        Details: " Details",
        LIKES: "Likes",
        PHONE: "Phone",
        BIRTHDATE: "Birthdate",
        TYPE: "Type",
        BIO: "Bio",
        UPDATED_AT: "Updated At",
        DISLIKES: "Dislikes",
        COMMENTS: "Comments",
        ADD_ARTICLE: "Add Article",
        ARTICLE_TITLE: "Article Title",
        ARTICLE_BODY: "Article Body",
        PRIMARY_IMAGE: "Primary Image",
        ADDITIONAL_IMAGES: "Additional Images",
        ADDITIONAL_IMAGES_HINT: "You can select multiple extra images for the article",
        SAVE_ARTICLE: "Save Article",
        ARTICLE_SAVED: "Article saved successfully",
        SELECT_FAKE_USER: "Select fake user",
        FAKE_USER_LABEL: "Fake User",
        FILL_REQUIRED_FIELDS: "Please complete the required fields",
        LIKE: "Like",
        DISLIKE: "Dislike",
        WRITE_COMMENT: "Write a comment",
        ADD_COMMENT: "Add Comment",
        COMMENT_ADDED: "Comment added successfully",
        COMMENT_DELETED: "Comment deleted successfully",
        ARTICLE_REACTION_UPDATED: "Article reaction updated successfully",
        TermsAndConditions: "Terms & Conditions",
        About: "About",
        Notifications: "Notifications",
        Currencies: "Currencies",
        Countries: "Countries",
        Cities: "Cities",
        plans: "plans",
        light: "light",
        root: "root",
        seed: "seed",
        soil: "soil",
        stem: "stem",
        counselorspayment: "counselorspayment",
        OpenScreens: "Open Screens",
        GanatakCommunity: "Ganatak Community",
        Paperform: "Paperform",
        Sizes: "Sizes",
        Sliders: "Sliders",
        MONETIZATION: "Monetization",
        MONETIZATION_TERMS: "Monetization Terms",
        MONETIZATION_REQUESTS: "Monetization Requests",
        REQUESTS: "Requests",
        DETAILS: "Details",
        USER: "User",
        REQUEST_STATUS: "Request status",
        ADMIN_NOTE: "Admin note",
        SELECTED_STORIES: "Selected stories",
        VIEW: "View",
        PENDING: "Pending",
        APPROVED: "Approved",
        REJECTED: "Rejected",
        DISABLED: "Disabled",
        ALL: "All",
        APPROVE: "Approve",
        REJECT: "Reject",
        DISABLE: "Disable",
        DISABLE_HINT: "Write a reason in admin note, then disable",
        ENABLE: "Re-enable",
        ENABLE_HINT: "Re-enable monetization for this request",
        STORIES: "Stories",
        PUBLISHED: "Published",
        SUBMITTED_AT: "Submitted at",
        PICK_REQUEST: "Pick a request to view details",
        STATUS_pending: "Pending admin approval",
        STATUS_approved: "Approved",
        STATUS_rejected: "Rejected",
        STATUS_disabled: "Disabled",
        TERMS_VERSIONS: "Versions",
        NEW: "New",
        VERSION: "Version",
        TITLE_AR: "Title (AR)",
        TITLE_EN: "Title (EN)",
        CONTENT_AR: "Content (AR)",
        CONTENT_EN: "Content (EN)",
        ACTIVE: "Active",
        INACTIVE: "Inactive",
        ACTIVATE: "Activate",
        TERMS_HINT: "Edit monetization terms in Arabic/English. The active version is shown in the app."

      },
      USERS_SECTION: "Customers",
      USERS: {
        LIST: "Users List",
        ADD: "Add User",
      },
      PRODUCTS: {
        Title: "Products",
        LIST: "Products List",
        AT_HOME: "Products at Home",
      },
      COUNSELORS: {
        Title: "Consultants",
        LIST: "Consultants List",
        ADD: "Add Consultant",
      },
      STORES: {
        Title: "Stores",
        LIST: "Stores List",
        ADD: "Add Store",
      },
      STORES_OFFERS: {
        Title: "Store Offers",
        LIST: "Offers List",
      },
      VOUCHER: {
        Title: "Promotions",
        TYPE: "Promotion Types",
        LIST: "Promotions List",
      },
      cancelation_reasons: {
        Title: "Cancellation Reason",
        LIST: "Cancellation Reasons List",
        ADD: "Add Reason",
      },
      COMPANIES: {
        Title: "Companies",
        LIST: "Companies List",
        ARCHIVED: "Archived Companies",
        ADD: "Add Company",
      },
      consulting: {
        Title: "Consulting",
        LIST: "Consulting List",
      },
      SERVICES: {
        Title: "Services",
        LIST: "Services List",
        ADD: "Add Service",
      },
      SECTION: {
        Title: "Sections",
        LIST: "Sections List",
        TYPES: "Voucher Types",
        ADD: "Add Section",
      },
      ARTICLES: {
        Title: "Articles",
        LIST: "Articles List",
        Plant_groups: "Plant Groups",
        ADD: "Add",
        various: "Various Agricultural Articles",
      },
      TAGS: {
        Title: "Tags",
        LIST: "Tags List",
        ADD: "Add Tag",
      },
      offers: {
        Title: "Offers",
        LIST: "Offers List",
        ADD: "Add Offers",
      },
      reasone_canceled: {
        Title: "Cancellation Reason",
        LIST: "List",
        ADD: "Add",
      },
      PLANTCARDS: {
        TITLE: "Plant Cards",
        LIST: "Plant Cards List",
        ADD: "Add Plant Card",
        LEAVERSCOLOR: {
          TITLE: "Leaf Colors",
          LIST: "Leaf Colors List",
          ADD: "Add Leaf Color",
        },
        LEAVERSFORM: {
          TITLE: "Leaf Shapes",
          LIST: "Leaf Shapes List",
          ADD: "Add Leaf Shape",
        },
        FLOWERFORM: {
          TITLE: "Flower Shapes",
          LIST: "Flower Shapes List",
          ADD: "Add Flower Shape",
        },
        FLOWERCOLOR: {
          TITLE: "Flower Colors",
          LIST: "Flower Colors List",
          ADD: "Add Flower Color",
        },
        ENVIRONMENTLIGHT: {
          TITLE: "Environmental Light",
          LIST: "Environmental Light List",
          ADD: "Add Environmental Light",
        },
        ENVIRONMENTTEMP: {
          TITLE: "Environmental Temperature",
          LIST: "Environmental Temperature List",
          ADD: "Add Environmental Temperature",
        },
        ENVIRONMENHUMIDITY: {
          TITLE: "Environmental Humidity",
          LIST: "Environmental Humidity List",
          ADD: "Add Environmental Humidity",
        },
        REPRODUCTIONS: {
          TITLE: "Reproduction",
          LIST: "Reproduction Methods List",
          ADD: "Add Reproduction Method",
        },
        PLANTCARDSOIL: {
          TITLE: "Soil Types",
          LIST: "Soil Types List",
          ADD: "Add Soil Type",
        },
      },
    },
  },
};
